export default "__VITE_ASSET__FC2x7S8g__"